import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import type { ApiRequestBody } from '@/types/utils/request';

type GenerateJobSkillsMutationInput = ApiRequestBody<'/ai/skills', 'post'>;

export const useJobSkillsMutation = () => {
  return useMutation({
    mutationFn: async ({
      title,
      description,
    }: GenerateJobSkillsMutationInput) => {
      const { data } = await fetchClient.POST('/ai/skills', {
        body: {
          title,
          description,
        },
      });
      return data;
    },
  });
};
